export const DEFAULT_PAGE_REVALIDATE_SECONDS = 300;

export const PAGE_ROUTES_WITHOUT_LAYOUT = new Set([
  '/_error',
  '/500',
  '/errors/not_found',
  '/pages/invalidate',
]);
